export default [
  {
    path: '/Customer-service',
    name: 'NewNotice',
    component: () => import('Components/Customer/content/NewNotice'),
  },
  {
    path: '/Customer-service/NewNoticeDetail/:id',
    name: 'NewNoticeDetail',
    component: () => import('Components/Customer/partials/NewNoticeDetail'),
  },
  {
    path: '/Customer-service/Reference-room',
    name: 'ReferenceRoom',
    component: () => import('Components/Customer/content/ReferenceRoom'),
  },
  {
    path: '/Customer-service/Reference-room/ReferenceDetail/:id',
    name: 'ReferenceDetail',
    component: () => import('Components/Customer/partials/ReferenceDetail'),
  },
]
